interface JWTPayload {
  exp?: number
  iat?: number
  sub?: string
  scopes?: string | string[]
  [key: string]: unknown
}

export function decodeJWT(token: string): JWTPayload | null {
  try {
    const parts = token.split('.')
    if (parts.length !== 3) {
      return null
    }

    const base64Url = parts[1]
    if (!base64Url) {
      return null
    }
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        })
        .join('')
    )

    return JSON.parse(jsonPayload) as JWTPayload
  } catch (error) {
    console.error('Failed to decode JWT:', error)
    return null
  }
}

export function isTokenExpired(token: string | null): boolean {
  if (!token) return true

  const payload = decodeJWT(token)
  if (!payload || !payload.exp) return true

  const expirationTime = payload.exp * 1000
  const currentTime = Date.now()

  return currentTime >= expirationTime - 60000
}

export function getTimeUntilExpiry(token: string | null): number {
  if (!token) return 0

  const payload = decodeJWT(token)
  if (!payload || !payload.exp) return 0

  const expirationTime = payload.exp * 1000
  const currentTime = Date.now()

  return Math.max(0, expirationTime - currentTime)
}
